import { Box, Button, Card, Grid, Icon, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { NavLink, useParams, useRouteMatch } from "react-router-dom";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import ConfirmationDialog from "../../../../utilities/components/ConfirmationDialog/ConfirmationDialog";
import ImageField from "../../../../utilities/components/ImageField/ImageField";
import { dataURLtoFile } from "../../../../utilities/utilityFunctions";
import {
  AutocompleteValidator,
  PhoneInputValidator,
} from "../../../../utilities/validators";
import UtilHelper from "../../../../utilities/validators/UtilHelper";
import {
  getRolesRequest,
  getSignedUrlRequest,
  getTimezonesRequest,
  getUserByIdRequest,
  updateUserRequest,
  uploadToS3Request,
} from "../../UsersApiActions";
import { useStyles } from "./styles";

/**
 * function to render doctor profile
 * @param history: history from router
 * @returns {JSX.Element}
 * @constructor
 */
const EditProfileFormForAdminUsers = ({
  history,
  location,
  getRoles,
  rolesData,
  getTimezones,
  timezones,
  getUserById,
  updateUser,
  getSignedUrl,
  uploadToS3,
}) => {
  const classes = useStyles();
  const params = useParams();
  const match = useRouteMatch();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [timezone, setTimezone] = useState(null);
  const [appointmentCharges, setAppointmentCharges] = useState(null);
  const [appointmentChargesOffline, setAppointmentChargesOffline] =
    useState(null);
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [rowImageFile, setRowImageFile] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);
  const [showImageEditor, setShowImageEditor] = useState(false);
  const currentUrlPath = match.path.split(":")[0];
  useEffect(() => {
    getRoles().then((res) => {});
  }, [getRoles]);

  useEffect(() => {
    getUserById(params.id).then((res) => {
      setCroppedImageFile(res.imageUrl);
      setFirstname(res.firstName);
      setLastname(res.lastName);
      setEmail(res.email);
      setPhone(res.phone);
      setTimezone(res.Timezone);
      setSelectedRole(res.Roles[0]);
      setAppointmentCharges(res.consultationFee);
      setAppointmentChargesOffline(res.consultationFeeOffline);
    });
  }, [params.id, getUserById]);

  useEffect(() => {
    ValidatorForm.addValidationRule("isBlank", (value) =>
      UtilHelper.validateBlankSpace(value)
    );
    ValidatorForm.addValidationRule("isValidMobile", (value) =>
      UtilHelper.validateMobile(value)
    );
    ValidatorForm.addValidationRule("isValidNPI", (value) =>
      UtilHelper.validateNpi(value)
    );
    ValidatorForm.addValidationRule("isMaxLength", (value) =>
      UtilHelper.validateMaxLength(value)
    );
    ValidatorForm.addValidationRule("isNumber", (value) => {
      return !isNaN(value);
    });

    ValidatorForm.addValidationRule("isInteger", (value) => {
      if (value === "") return true;
      return Number.isInteger(Number(value));
    });

    ValidatorForm.addValidationRule("isNonNegative", (value) => {
      if (value === "") return true;
      return Number(value) >= 0;
    });

    return () => {
      ValidatorForm.removeValidationRule("isBlank");
      ValidatorForm.removeValidationRule("isValidMobile");
      ValidatorForm.removeValidationRule("isValidNPI");
      ValidatorForm.removeValidationRule("isMaxLength");
      ValidatorForm.removeValidationRule("isNumber");
      ValidatorForm.removeValidationRule("isInteger");
      ValidatorForm.removeValidationRule("isNonNegative");
    };
  }, []);

  useEffect(() => {
    getTimezones().then((res) => {});
  }, [getTimezones]);

  const breadCrumbDataForEditUserForm = [
    {
      icon: "group",
      name: "Users",
      path: "/users",
    },
    {
      name: `Update User`,
      path: `/users/edit/${params.id}`,
    },
  ];

  const breadCrumbDataForUpdateOrgDoctorForm = [
    {
      icon: "business",
      name: "Clinics",
      path: "/orgs",
    },
    {
      name: `${
        location.state && location.state
          ? `${location.state.orgNameHistory}`
          : ""
      }`,
      path: `/orgs/${location.state && location.state.orgIdHistory}`,
    },
    {
      name: `Update Doctor`,
      path: `/orgs/doctors/edit/${params.id}`,
    },
  ];

  const breadCrumbDataForUpdateOrgAdminForm = [
    {
      icon: "business",
      name: "Clinics",
      path: "/orgs",
    },
    {
      name: `${
        location.state && location.state
          ? `${location.state.orgNameHistory}`
          : ""
      }`,
      path: `/orgs/${location.state && location.state.orgIdHistory}`,
    },
    {
      name: `Update Administrator`,
      path: `/orgs/admins/edit/${params.id}`,
    },
  ];

  const breadCrumbDataForUpdateOrgDeptDoctorForm = [
    {
      icon: "business",
      name: "Clinics",
      path: "/orgs",
    },
  ];

  const breadCrumbDataForUpdateOrgDeptAdminForm = [
    {
      icon: "business",
      name: "Clinics",
      path: "/orgs",
    },
  ];

  const breadCrumbDataForUpdateAdminDeptDoctorForm = [
    {
      icon: "apartment",
      name: "Departments",
      path: "/departments",
    },
    {
      name: `${
        location.state && location.state
          ? `${location.state.deptNameHistory}`
          : ""
      }`,
      path: `/departments/${location.state && location.state.deptIdHistory}`,
    },
    {
      name: `Update Doctor`,
      path: `/departments/doctors/edit/${params.id}`,
    },
  ];

  /**
   * function to get breadcrumb data for current url
   * @returns {[{path: string, icon: string, name: string}, {path: string, name: string}, {path: string, name: string}, {path: string, name: string}, {path: string, name: string}]|[{path: string, icon: string, name: string}, {path: string, name: string}]|[{path: string, icon: string, name: string}, {path: string, name: string}, {path: string, name: string}]|[{path: string, icon: string, name: string}, {path: string, name: string}, {path: string, name: string}, {path: string, name: string}]|*[]}
   */
  const getBreadcrumbData = (urlPath) => {
    switch (urlPath) {
      case "/orgs/doctors/edit/": {
        return breadCrumbDataForUpdateOrgDoctorForm;
      }
      case "/users/edit/": {
        return breadCrumbDataForEditUserForm;
      }
      case "/orgs/admins/edit/": {
        return breadCrumbDataForUpdateOrgAdminForm;
      }
      case "/orgs/departments/doctors/edit/": {
        return breadCrumbDataForUpdateOrgDeptDoctorForm;
      }
      case "/orgs/departments/admins/edit/": {
        return breadCrumbDataForUpdateOrgDeptAdminForm;
      }
      case "/departments/doctors/edit/": {
        return breadCrumbDataForUpdateAdminDeptDoctorForm;
      }
      default: {
        return [];
      }
    }
  };

  /**
   * function to handle image crop
   */
  const onImageCrop = () => {
    const croppedImageDataUrl = cropper.getCroppedCanvas().toDataURL();
    const croppedImageFileObject = dataURLtoFile(
      croppedImageDataUrl,
      rowImageFile[0].file.name
    );

    const data = {
      dataURL: croppedImageDataUrl,
      file: croppedImageFileObject,
    };

    setCroppedImageFile(data);
    setShowImageEditor(false);
  };

  /**
   * function to handle update existing user
   * @param e: event object on form submission
   */
  const onUpdate = async (e) => {
    e.preventDefault();
    try {
      let imageUrl = null;

      if (typeof croppedImageFile !== "string") {
        const { name: fileName } = croppedImageFile.file;
        const fileType = `.${fileName.split(".").pop()}`;

        const res = await getSignedUrl({ fileName, fileType });
        await uploadToS3(res.urls, croppedImageFile.file);
        imageUrl = res.path;
      }

      const data = {
        email,
        phone,
        firstName: firstname,
        lastName: lastname,
        roles: [selectedRole.name],
        TimezoneId: timezone.id,
        consultationFee:
          selectedRole.name === "Doctor" && appointmentCharges !== ""
            ? Number(appointmentCharges)
            : null,
        consultationFeeOffline:
          selectedRole.name === "Doctor" && appointmentChargesOffline !== ""
            ? Number(appointmentChargesOffline)
            : null,
        ...(imageUrl && { imageUrl }),
      };

      await updateUser(params.id, data);
      history.goBack();
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  /**
   * function to handle cancel add or update
   */
  const handleCancel = () => {
    history.goBack();
  };

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {
                orgIdHistory: location.state && location.state.orgIdHistory,
                orgNameHistory: location.state && location.state.orgNameHistory,
                deptIdHistory: location.state && location.state.deptIdHistory,
                deptNameHistory:
                  location.state && location.state.deptNameHistory,
              },
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>

      <Box>
        <ValidatorForm autoComplete="off" onSubmit={onUpdate}>
          <Box className={classes.outerFormContainer}>
            <Box component={Paper} className={classes.mainFormContainer}>
              <Grid container spacing={2} justify="space-around">
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Box>
                    <ImageField
                      rowImageFile={rowImageFile}
                      setRowImageFile={setRowImageFile}
                      showImageEditor={showImageEditor}
                      setShowImageEditor={setShowImageEditor}
                      setCropper={setCropper}
                      croppedImageFile={croppedImageFile}
                      onImageCrop={onImageCrop}
                      options={{
                        shape: "circle",
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextValidator
                        label="Email *"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        validators={["required", "isEmail"]}
                        errorMessages={["Email is required", "Invalid email"]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <PhoneInputValidator
                        autoFormat={false}
                        variant="outlined"
                        size="small"
                        label="Phone *"
                        fullWidth
                        defaultCountry="in"
                        countryCodeEditable={false}
                        value={phone}
                        onChange={(phone, data) => {
                          let phoneNumber = "+" + phone.replace(/[^0-9]+/g, "");
                          setPhone(phoneNumber);
                        }}
                        validators={["required", "isValidMobile"]}
                        errorMessages={[
                          "Phone is required",
                          "Please enter valid phone",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextValidator
                        label="First Name *"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        validators={["required", "isBlank", "isMaxLength"]}
                        errorMessages={[
                          "Firstname is required",
                          "Please enter first name",
                          "Maximum 100 letters are accepted.",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextValidator
                        label="Last Name *"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        validators={["required", "isBlank", "isMaxLength"]}
                        errorMessages={[
                          "Last Name is required",
                          "Please enter last name",
                          "Maximum 100 letters are accepted.",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {selectedRole?.name === "Clinic Owner" ? (
                        <TextValidator
                          fullWidth
                          size="small"
                          label="Role"
                          value="Clinic Owner"
                          variant="outlined"
                          InputProps={{ readOnly: true }}
                        />
                      ) : (
                        <AutocompleteValidator
                          fullWidth
                          size="small"
                          value={selectedRole}
                          onChange={(e, value) => {
                            setSelectedRole(value);
                            if (value?.name !== "Doctor") {
                              setAppointmentCharges(null);
                            }
                          }}
                          options={rolesData.filter((role) =>
                            ["Doctor", "Receptionist", "Org Admin"].includes(
                              role.name
                            )
                          )}
                          getOptionLabel={(option) => option.name}
                          getOptionSelected={(option, value) => {
                            if ((option, value)) {
                              return option.id === value.id;
                            } else {
                              return true;
                            }
                          }}
                          renderInput={(params) => (
                            <TextValidator
                              {...params}
                              label="Role *"
                              variant="outlined"
                            />
                          )}
                          validators={["required"]}
                          errorMessages={["Role is required"]}
                        />
                      )}
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <AutocompleteValidator
                        fullWidth
                        size="small"
                        value={timezone}
                        onChange={(e, value) => {
                          setTimezone(value);
                        }}
                        options={timezones}
                        getOptionLabel={(option) => {
                          return (
                            option.description.charAt(0).toUpperCase() +
                            option.description.slice(1)
                          );
                        }}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        renderInput={(params) => (
                          <TextValidator
                            {...params}
                            label="Select Timezone *"
                            variant="outlined"
                          />
                        )}
                        validators={["required"]}
                        errorMessages={["Timezone is required"]}
                      />
                    </Grid>
                    {selectedRole?.name === "Doctor" && (
                      <>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <TextValidator
                            label="Appointment Charges (Online) *"
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="number"
                            value={appointmentCharges}
                            onChange={(e) =>
                              setAppointmentCharges(e.target.value)
                            }
                            validators={[
                              "required",
                              "isNumber",
                              "isInteger",
                              "isNonNegative",
                            ]}
                            errorMessages={[
                              "This field is required",
                              "Input must be a number",
                              "Only integers allowed",
                              "Negative values are not allowed",
                            ]}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <TextValidator
                            label="Appointment Charges (Offline) *"
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="number"
                            value={appointmentChargesOffline}
                            onChange={(e) =>
                              setAppointmentChargesOffline(e.target.value)
                            }
                            validators={[
                              "required",
                              "isNumber",
                              "isInteger",
                              "isNonNegative",
                            ]}
                            errorMessages={[
                              "This field is required",
                              "Input must be a number",
                              "Only integers allowed",
                              "Negative values are not allowed",
                            ]}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box className={classes.formFooterOuterContainer}>
              <Box
                component={Card}
                raised
                className={classes.formFooterContainer}
              >
                <Box>
                  <Button
                    variant="outlined"
                    color="primary"
                    disableElevation={true}
                    onClick={() => setOpenCancelConfirmation(true)}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    type="submit"
                    className={classes.saveButton}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </ValidatorForm>

        <Box>
          <ConfirmationDialog
            open={openCancelConfirmation}
            setOpen={setOpenCancelConfirmation}
            title="Cancel"
            message="Are you sure you want to cancel?"
            onConfirm={handleCancel}
          />
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    departmentData: state.departments.depts,
    rolesData: state.ayucareUsers.roles,
    timezones: state.ayucareUsers.timezones,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRoles: () => {
      return dispatch(getRolesRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getUserById: (id) => {
      return dispatch(getUserByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateUser: (id, data) => {
      return dispatch(updateUserRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getTimezones: () => {
      return dispatch(getTimezonesRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProfileFormForAdminUsers);
